import * as classnames from 'classnames'
import * as React from 'react'
import { Link } from 'react-router'

import { Plan } from '../../../../commons/Plan'
import Button from '../../atoms/Button/Button'
import EditorQuizURLModalItem from '../EditorQuizURLModalItem/EditorQuizURLModalItem'
import * as styles from './EditorQuizURLModal.css'

interface EditorQuizURLModalProps {
  shareParam: string
  plan: Plan
  isModalShow: boolean
  hideModal: () => void
  handleChangeAccept: (input: boolean) => void
  isStarted: boolean
  expireDate: string
  handleClickOpenPresentationWindow: () => void
  handleDownloadRankingData: () => void
  isFetchableRankingData: boolean
}

class EditorQuizURLModal extends React.PureComponent<EditorQuizURLModalProps> {
  constructor(props: any) {
    super(props)
  }
  public render() {
    const {
      shareParam,
      plan,
      isModalShow,
      hideModal,
      isStarted,
      expireDate,
      handleChangeAccept,
      handleClickOpenPresentationWindow,
      handleDownloadRankingData,
      isFetchableRankingData
    } = this.props

    let limitationText = '10人まで参加可能'
    if (plan === Plan.SAFETY) {
      limitationText = `300人まで参加可能(有効期限: ${expireDate.replace(/\./g, '/')})`
    } else if (plan === Plan.LIGHT) {
      limitationText = `50人まで参加可能(有効期限: ${expireDate.replace(/\./g, '/')})`
    } else if (plan === Plan.PRO) {
      limitationText = `500人まで参加可能(有効期限: ${expireDate.replace(/\./g, '/')})`
    } else if (plan === Plan.ENTERPRISE) {
      limitationText = `1000人まで参加可能(有効期限: ${expireDate.replace(/\./g, '/')})`
    }

    let noticePart: any = null
    if (plan === Plan.FREE) {
      noticePart = (
        <React.Fragment>
          <p className={styles.main}>
            お手軽プラン(税込8053円)なら
            <br />
            11人以上の参加者が集まっても大丈夫
          </p>
          <div className={styles.button}>
            <Link to="/payment">
              <Button>
                <p className={styles.buttonText}>プランを選ぶ</p>
              </Button>
            </Link>
          </div>
        </React.Fragment>
      )
    }

    return (
      <div className={classnames(styles.container, isModalShow ? styles.fadein : null)} onClick={hideModal}>
        <div className={styles.subContainer} onClick={e => e.stopPropagation()}>
          <div className={styles.closeHeader}>
            <div className={styles.closeButton} onClick={hideModal}>
              <div className={styles.closeIcon} />
            </div>
          </div>
          <div className={styles.titlePart}>
            <div className={styles.row}>
              <p className={styles.title}>クイズを開始</p>
              <p className={styles.limitationText}>{limitationText}</p>
              <p className={styles.notice}>
                URLはプロジェクトごとに設定され プランの購入状態が変わってもURLは変わりません
              </p>
            </div>
          </div>
          <div className={styles.urlPart}>
            <EditorQuizURLModalItem
              shareParam={shareParam}
              isAcceptParticipant={isStarted}
              handleChangeAccept={handleChangeAccept}
              handleClickOpenPresentationWindow={handleClickOpenPresentationWindow}
              handleDownloadRankingData={handleDownloadRankingData}
              isFetchableRankingData={isFetchableRankingData}
            />
          </div>
          {noticePart ? <div className={styles.noticePart}>{noticePart}</div> : null}
        </div>
      </div>
    )
  }
}

export default EditorQuizURLModal
